export default __webpack_public_path__ + "static/media/download.f4c49e3a.svg";